export default {
      id: "edit-pen copy-usage",
      viewBox: "0 0 41 40",
      url: __webpack_public_path__ + "img/icons.e22fd14f.svg#edit-pen copy",
      toString: function () {
        return this.url;
      }
    }